import { useTranslation } from 'react-i18next';
import { SocialButton } from '@anytag/shared-atoms';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { SupportedSocialMediaType } from '@anytag/shared-types';
import { cn, formatIntNumber } from '@anytag/shared-utils';

export interface ConnectableAccountType {
  id: string;
  name: string;
  avatar: string;
  isUsed?: boolean;
  friends?: number;
  followers?: number;
  isSelected?: boolean;
  socialMedia?: keyof typeof SupportedSocialMediaType;
}

interface ConnectableAccountProps {
  className?: string;
  account: ConnectableAccountType;
  socialMedia?: keyof typeof SupportedSocialMediaType;
}

export const ConnectableAccount = ({ account, socialMedia, className }: ConnectableAccountProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex w-full items-center', className)}>
      <div className="flex flex-none items-center justify-center">
        {socialMedia ? (
          <SocialButton
            iconProps={{ size: '24' }}
            socialMedia={socialMedia}
            className="size-10.5 justify-center rounded-full p-0"
            hasIcon
          />
        ) : null}
        <InfluencerAvatar
          size="42px"
          src={account.avatar}
          className="-ml-2 size-12 rounded-full border-3 border-white"
        />
      </div>

      <div className="ml-2 flex-1 text-black-90">
        <p className="text-base leading-none">{account.name}</p>
        <p className="mt-1.25 text-sm leading-[1.17] text-black-60">
          <span>{formatIntNumber(account.followers ?? account.friends)}</span>&nbsp;
          <span>{t(typeof account.friends === 'number' ? 'Friends' : 'Followers')}</span>
        </p>
      </div>
    </div>
  );
};
